module.exports = __webpack_public_path__ + "img/__icon_NISKOPODŁOGOWY.16051df6.svg";